'use client';

import { Session } from 'next-auth';
import {
	HeroSection,
	ProblemSection,
	SolutionSection,
	PricingSection,
	Footer
} from './ui';

// Simple client component for landing page only (non-logged-in users)
export default function NosLeadClient({ 
	initialSession, 
	searchParams 
}: { 
	initialSession: Session | null;
	searchParams?: { domain?: string; goal?: string; ist?: string };
}) {
	return (
		<div className="min-h-screen">
			<HeroSection initialSession={initialSession} searchParams={searchParams} />
			<ProblemSection />
			<SolutionSection />
			<PricingSection />
			<Footer />
		</div>
	);
}
